import { Component } from '@angular/core';
import { LanguageService } from './services/language.service';

@Component({
  selector: 'mcrit-gestio-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Mcrit gestió';
  private menuVisible: boolean = false;

  public toggleMenu() {this.menuVisible=!this.menuVisible;return this.menuVisible;}

}


